// removed by extract-text-webpack-plugin
module.exports = {"page-title":"Resume__page-title___3XXrs typography__title___3pJfO","section-title":"Resume__section-title___1FxO0 typography__title___3pJfO","resume":"Resume__resume___3DOeC"};


//////////////////
// WEBPACK FOOTER
// ./application/js/pages/Resume.css
// module id = 530
// module chunks = 0